import { MobileHeader } from './MobileHeader'
import type { MobileHeaderProps } from './MobileHeader'
import { MobileBottomNav } from './MobileBottomNav'

export type MobileChromeProps = MobileHeaderProps

/**
 * Mobile chrome replacement (WARGAME 18 D2) — swapped in for
 * SafetyStrip + the desktop header + `.shell-switcher-row` by AppShell's
 * fragment ternary when `useIsMobile()` is true. Pure composition: all
 * props are AppShell state/handlers threaded straight through to
 * MobileHeader (no lifting, no new hooks here) per D2's locked branch
 * shape. MobileBottomNav needs nothing from AppShell — it reads
 * `useBooks()` directly. MobileTimeframeRow is rendered by MobileHeader
 * itself (as the last child inside `<header>`) rather than here, so it
 * shares the header's single sticky block instead of pinning itself at a
 * fixed offset that goes stale whenever the header grows.
 */
export function MobileChrome(props: MobileChromeProps) {
  return (
    <>
      <MobileHeader {...props} />
      <MobileBottomNav />
    </>
  )
}
